import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FaBriefcase, FaDollarSign, FaFileInvoice, FaUserTie } from "react-icons/fa";
import ContactCTA from "../components/ContactCTA";
import { useLanguage } from "../context/LanguageContext";

const Services = () => {
  const location = useLocation();
  const { t } = useLanguage();

  const services = [
    {
      title: t("servicesPage.items.bookkeeping.title"),
      description: t("servicesPage.items.bookkeeping.description"),
      icon: <FaFileInvoice className="text-yellow-600 text-8xl" />,
      image: "/assets/images/services/bookkeeping.jpg",
      reverse: false,
      id: "bookkeeping",
    },
    {
      title: t("servicesPage.items.payroll.title"),
      description: t("servicesPage.items.payroll.description"),
      icon: <FaDollarSign className="text-yellow-600 text-8xl" />,
      image: "/assets/images/services/payroll.jpg",
      reverse: true,
      id: "payroll",
    },
    {
      title: t("servicesPage.items.taxes.title"),
      description: t("servicesPage.items.taxes.description"),
      icon: <FaBriefcase className="text-yellow-600 text-8xl" />,
      image: "/assets/images/services/taxes.jpg",
      reverse: false,
      id: "taxes",
    },
    {
      title: t("servicesPage.items.consulting.title"),
      description: t("servicesPage.items.consulting.description"),
      icon: <FaUserTie className="text-yellow-600 text-8xl" />,
      image: "/assets/images/services/consulting.jpg",
      reverse: true,
      id: "consulting",
    },
  ];

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        setTimeout(() => {
          sectionElement.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="bg-white text-gray-900">
      <section className="relative w-full h-screen flex items-center justify-center text-center text-white">
        <div className="absolute inset-0">
          <img src="/assets/images/services/services.jpg" alt={t("common.servicesHeroAlt")} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10"
        >
          <h1 className="text-6xl font-bold">{t("servicesPage.heroTitle")}</h1>
          <p className="text-xl text-gray-300 mt-4 max-w-3xl mx-auto">{t("servicesPage.heroSubtitle")}</p>
        </motion.div>
      </section>

      {services.map((service) => (
        <section key={service.id} id={service.id} className="relative min-h-screen w-full flex items-center">
          <div className="absolute inset-0 w-full h-full">
            <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
            <div className={`absolute inset-0 ${service.reverse ? "bg-black/40" : "bg-black/20"}`}></div>
          </div>

          <motion.div
            initial={{ opacity: 0, x: service.reverse ? 50 : -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className={`relative z-10 container mx-auto px-12 flex flex-col md:flex-row ${
              service.reverse ? "md:flex-row-reverse" : ""
            } items-center gap-12`}
          >
            <div className="text-yellow-600 text-8xl">{service.icon}</div>

            <div className="md:w-1/2 text-center md:text-left text-white">
              <h2 className="text-5xl font-bold">{service.title}</h2>
              <p className="text-xl mt-4">{service.description}</p>
            </div>
          </motion.div>
        </section>
      ))}

      <ContactCTA />
    </div>
  );
};

export default Services;
